module.exports = __webpack_public_path__ + "img/thumb_06.e8bbd243.jpg";